import React, { useEffect, useRef, useState } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import paymentMessages from '../payment/paymentMessages';
import { STEP_UP_TIMEOUT_SECONDS } from './StepUp';

export const StepUpPopOut = ({ intl }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const merchantData = urlParams.get('merchantData');
    const enrollmentAccessToken = urlParams.get('enrollmentAccessToken');
    const stepUpUrl = urlParams.get('stepUpUrl');
    const stepUpForm = useRef();
    const [hasSubmitted, setHasSubmitted] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            window.close();
        }, STEP_UP_TIMEOUT_SECONDS * 1000);
    }, []);

    useEffect(() => {
        if (stepUpForm.current && !hasSubmitted) {
            setHasSubmitted(true);
            stepUpForm.current.submit();
        }
    }, [stepUpForm]);

    return (
        <div
            className="container"
            style={{
                margin: '0',
                maxWidth: '100%',
                height: '100%'
            }}
        >
            <h2 className="page-header" style={{ marginTop: '10px' }}>
                <span>{ intl.formatMessage(paymentMessages.stepUpPleaseAuthenticate) }</span>
            </h2>
            <iframe title="StepUpAuth" name="step-up-iframe" height="375" width="375" style={{ display: 'block' }} />
            <form
                id="step-up-form"
                target="step-up-iframe"
                ref={stepUpForm}
                method="POST"
                action={stepUpUrl}
                data-testid="step-up-form"
            >
                <input
                    type="hidden"
                    name="JWT"
                    value={enrollmentAccessToken}
                />
                <input
                    type="hidden"
                    name="MD"
                    value={merchantData}
                />
            </form>
        </div>
    );
};

StepUpPopOut.propTypes = {
    intl: intlShape.isRequired
};

export default injectIntl(StepUpPopOut);
